<template>
    <div id="congratulations-content" class="congratulations-content align-items-center justify-content-center">
        <h3 class="w-100 mb-0">
            Parabéns! </br>
            Tudo pronto para você começar </br>
            a usar o Salesflow!
        </h3>
            <CongratulationContentExampleDataSection
                @toggle-changed="handleToggleChanged"
            />
        <button
            id="congratulations-content-button"
            class="w-100 salesflow-btn salesflow-btn-primary"
            v-on:click.prevent="startUsing"
        >
            {{ buttonText }}
        </button>
    </div>
</template>

<script>
import CongratulationContentExampleDataSection from './CongratulationContentExampleDataSection.vue'

export default {
    props: {
      state: Object,
    },

    components: {
        CongratulationContentExampleDataSection
    },

    mounted() {
        window.addEventListener('resize', this.updateWindowWidth);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.updateWindowWidth);
    },

    data() {
        return {
            windowWidth: window.innerWidth
        }
    },

    computed: {
        buttonText() {
            return this.windowWidth < 744 ? 'Concluir' : 'Começar a usar';
        }
    },

    methods: {
        startUsing() {
            this.$emit('success', this.state);
        },

        handleToggleChanged(toggleValue) {
            this.state.mockData = toggleValue;
            this.$emit('state:changed', this.state);
        },

        updateWindowWidth() {
            this.windowWidth = window.innerWidth;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.congratulations-content {
    background-color: $white-3;
    width: 100%;
    display: flex;
    flex-direction: column;
    font-family: 'Inter';
    gap: 1.5rem 0;

    h3 {
        color: $salesflow-font-gray;
        font-size: 20px;
        font-weight: 500;
        line-height: 150%;
    }

    p {
        font-weight: 500;
        font-size: 1rem;
        line-height: 1.5rem;
        text-align: center;
        color: $salesflow-font-gray;
    }

    button {
        font-family: 'Inter';
        font-weight: 500;
        height: 45px;
    }
}

@media screen and (max-width: 350px) {
    .congratulations-content {
        h3 {
            font-size: 18px;
        }
    
    }
}

@media screen and (min-width: 744px) {
    .congratulations-content {
        h3 {
            font-size: 24px;
        }
    }
}

@media (min-width: 744px) and (max-height: 540px) {
  h3 {
    font-size: 20px !important;
  }
}
</style>
